import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { DataSourceListActions } from './data-source-list.store';
import { ViewsHttpService } from '../../services/views-http.service';

@Injectable({ providedIn: 'root' })
export class DataSourceListEffects {
  public effect = createEffectFactory(DataSourceListActions, this.actions$);

  public createOne$ = this.effect(DataSourceListActions.fetch, () =>
    this.viewsHttpService.listDataSources(),
  );

  constructor(
    private actions$: Actions,
    private viewsHttpService: ViewsHttpService,
  ) {}
}
